import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Reveal } from './ui/Reveal';
import { Mail, Linkedin, ShieldCheck } from 'lucide-react';
export function ContactSection() {
  return <Section id="contact" variant="charcoal" data-id="element-82">
      <SectionHeader title="Let's Connect" subtitle="Open to Opportunities" data-id="element-83" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-84">
        <Reveal data-id="element-85">
          <div className="space-y-8" data-id="element-86">
            <p className="text-lg text-slate-300 leading-relaxed" data-id="element-87">
              Actively seeking executive roles, board appointments, and
              strategic advisory engagements in defense, aerospace, and federal
              contracting. All inquiries handled with strict confidentiality.
            </p>

            <div className="space-y-4" data-id="element-88">
              <div className="flex items-center gap-4" data-id="element-89">
                <div className="w-10 h-10 bg-navy-900 border border-gold-500 flex items-center justify-center" data-id="element-90">
                  <Mail className="text-gold-500 w-5 h-5" data-id="element-91" />
                </div>
                <div data-id="element-92">
                  <h4 className="text-xs font-heading uppercase tracking-widest text-slate-500" data-id="element-93">
                    Email
                  </h4>
                  <a href="mailto:guy.beougher@gmail.com" className="text-white hover:text-gold-500 transition-colors" data-id="element-94">
                    guy.beougher@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4" data-id="element-95">
                <div className="w-10 h-10 bg-navy-900 border border-gold-500 flex items-center justify-center" data-id="element-96">
                  <Linkedin className="text-gold-500 w-5 h-5" data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <h4 className="text-xs font-heading uppercase tracking-widest text-slate-500" data-id="element-99">
                    LinkedIn
                  </h4>
                  <a href="https://linkedin.com/in/guybeougher" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gold-500 transition-colors" data-id="element-100">
                    linkedin.com/in/guybeougher
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4" data-id="element-101">
                <div className="w-10 h-10 bg-navy-900 border border-gold-500 flex items-center justify-center" data-id="element-102">
                  <ShieldCheck className="text-gold-500 w-5 h-5" data-id="element-103" />
                </div>
                <div data-id="element-104">
                  <h4 className="text-xs font-heading uppercase tracking-widest text-slate-500" data-id="element-105">
                    Clearance Status
                  </h4>
                  <span className="text-white" data-id="element-106">Active Top Secret / SCI</span>
                </div>
              </div>
            </div>

            {/* Headshot */}
            <div className="mt-8 border border-gold-500/30 bg-navy-900 p-3 max-w-xs shadow-[0_0_20px_rgba(197,165,90,0.1)]" data-id="element-107">
              <img src="https://cdn.magicpatterns.com/uploads/qHTWKxA3Q89G5ZvNigM12i/1698369576334.jpg" alt="Guy C. Beougher" className="w-full object-cover object-top aspect-[3/4]" data-id="element-108" />
              <p className="text-center text-xs font-heading uppercase tracking-widest text-gold-500 mt-3 pb-1" data-id="element-109">
                Guy C. Beougher
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={200} data-id="element-110">
          <div className="bg-navy-900 border border-white/5 h-full overflow-hidden" data-id="element-111">
            <div className="p-8 pb-4" data-id="element-112">
              <h3 className="text-xl font-bold text-white uppercase mb-2" data-id="element-113">
                Send a Message
              </h3>
              <p className="text-slate-400 text-sm" data-id="element-114">
                All submissions go directly to my inbox.
              </p>
            </div>
            <iframe src="https://form.jotform.com/260597304982062" title="Contact Form" className="w-full border-0" style={{
            minHeight: '500px'
          }} allow="geolocation; microphone; camera" allowFullScreen data-id="element-115" />
          </div>
        </Reveal>
      </div>
    </Section>;
}